import { getSureStartProgramData } from './add-Page-Type-DataLayer';

declare global {
    interface Window {
      dataLayer: any[];
    }
}

export interface IGTMCustomEvent {
    event: string;
    locationID: string | null;
    locationDBA: string | null;
    submitType: string;
    formType: string;
    formDescription: string;
    formStatus: string;
}

export function pushGTMEvent(eventObj: IGTMCustomEvent){
    try {
        if (!window?.dataLayer) {
            console.warn('GTM event push failed:');
        }
        window.dataLayer.push({
            ...eventObj,
            ...getSureStartProgramData()
        });
    } catch (error) {
        console.warn('GTM event push failed:', error);
    }
}
   

export const clearAllGTMTrackedEvents = (eventType: string = '') => {
    let dataLayer = (window as any).dataLayer;
    if (!dataLayer) {
        console.warn('GTM dataLayer not found. Event(s) not cleared:', eventType);
        return;
    }

    for (let i = dataLayer.length - 1; i >= 0; i--) {
        if (dataLayer[i]?.['event'] === eventType) {
            dataLayer.splice(i, 1);
        }
    }
};

export const getFormattedFormDesc = (): string => {
    const parts: string[] = [];
    const payload = JSON.parse(sessionStorage.getItem('formValues') ?? '{}') ?? {};

    //Service Type - residential / commercial
    if(payload?.servicetype) parts.push(payload.servicetype);

    //Appliance-name + Service 
    if (payload?.serviceRequestImage) parts.push(payload.serviceRequestImage?.[0]?.label?.replace(/ /g, '_') ?? '');
    if (payload?.applianceBrand?.makeName) parts.push(payload.applianceBrand.makeName.replace(/ /g, '_'));

    //Customer Type - residential / commercial
    //Job Frequency - one-time / recurring
    if(payload?.customerType) parts.push(payload.customerType)
    if(payload?.jobFrequency) parts.push(payload.jobFrequency)

    //How did you hear about us    
    if(payload?.leadSourceName) parts.push(payload.leadSourceName.replace(/ /g, '_'));

    // Final formDescription
    const formDescription = parts?.length > 0 ? parts.join('_') : '';
  
    return formDescription;
};
  

export function createGTMRequestEstimateEvt(submitType: string, formType: string, formStatus: string, formDescription: string) {
    const doingBusinessAs = localStorage.getItem('doingBusinessAs') ? localStorage.getItem('doingBusinessAs') : '';
    const weblocID = localStorage.getItem('weblocationId') ? localStorage.getItem('weblocationId') : '';
    let eventObj: IGTMCustomEvent = {
        event: 'request_estimate',
        locationID: weblocID,
        locationDBA: doingBusinessAs,
        submitType: submitType,
        formType: formType,
        formDescription: formDescription,
        formStatus: formStatus
    }
    pushGTMEvent(eventObj);
    sessionStorage.setItem('request_estimate', JSON.stringify(eventObj));
}

export const gtmClearEventTimeout = () => {
    setTimeout(() => {
        clearAllGTMTrackedEvents('request_estimate');
    }, Number(process.env.GTM_EVENT_CLEAR_TIMEOUT) || 300);
}

export function fireGTMEvent(status: string, payload: any, isShortForm: boolean) {
    if (isShortForm) {
        createGTMRequestEstimateEvt('request-call-back', 'short-form', status, payload?.customerType ?? '');
    } else {
        let formDescription = getFormattedFormDesc();

        const isRequestCallBackChecked = (JSON.parse(sessionStorage.getItem('isRequestCallBackChecked') as string) ?? false) as boolean;
        const submitActionType = isRequestCallBackChecked ? 'request_call_back' : 'submit_and_continue';
        const submitType = payload?.isLeadOnly ? submitActionType : 'full_form_submit';

        createGTMRequestEstimateEvt(submitType, 'long-form', status, formDescription);
    }
    gtmClearEventTimeout();
}